<template>
  <v-data-table
    class="dashboard-data-table"
    :headers="vuetifyHeaders"
    :items="rows"
    :item-key="itemKey"
    :hide-default-footer="hideDefaultFooter"
    :disable-pagination="hideDefaultFooter"
    :disable-sort="disableSort"
    :group-by="effectiveGroupBy"
    :server-items-length="serverItemsLength"
    :options="options"
    :footer-props="{ 'items-per-page-options': [5, 10, 15, 25, 50] }"
    @update:options="$emit('update:options', $event)"
  >
    <template
      v-for="column in columns"
      v-slot:[`item.${column.key}`]="{ item }"
    >
      <slot
        name="cell"
        :column="column"
        :row="item"
      >
        <BaseDashboardTableCell
          :column="column"
          :row="item"
          @detail="$emit('detail', item)"
        />
      </slot>
    </template>

    <template v-slot:group.header="{ group, isOpen, toggle }">
      <td
        :colspan="columns.length"
        class="dashboard-data-table__group-header"
        @click="toggle && toggle()"
      >
        <span class="dashboard-data-table__group-arrow">{{ isOpen ? '▾' : '▸' }}</span>
        {{ group }}
      </td>
    </template>

    <template v-slot:group.summary="{ group }">
      <td
        v-for="column in columns"
        :key="column.key"
        :class="`text-${column.align || 'start'}`"
      >
        <BaseDashboardTableCell
          :column="column"
          :row="(group && groupSubtotals[group]) || {}"
        />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import BaseDashboardTableCell from './BaseDashboardTableCell.vue'

export default {
  name: 'BaseDashboardTable',
  components: { BaseDashboardTableCell },
  props: {
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: false,
      default: undefined
    },
    hideDefaultFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    disableSort: {
      type: Boolean,
      required: false,
      default: false
    },
    groupBy: {
      type: String,
      required: false,
      default: ''
    },
    groupSubtotals: {
      type: Object,
      required: false,
      default: () => ({})
    },
    serverItemsLength: {
      type: Number,
      required: false,
      default: -1
    },
    options: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    vuetifyHeaders() {
      return this.columns.map((column) => ({
        text: column.label,
        value: column.key,
        align: column.align || 'start',
        sortable: !this.disableSort
      }))
    },
    effectiveGroupBy() {
      return this.groupBy || null
    }
  }
}
</script>

<style lang="scss">
.dashboard-data-table.v-data-table {
  border: 1px solid var(--ds-color-black-010);
  border-radius: 8px;
  overflow: hidden;
  background: transparent;

  .v-data-table-header {
    background: var(--ds-color-black-005);

    th {
      font-size: 0.75rem;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      color: var(--ds-color-black-055) !important;
      font-weight: 700;
    }
  }

  td {
    font-size: 0.875rem;
    height: auto !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    color: var(--v-textPrimary-base);
  }

  .v-row-group__header {
    background: var(--ds-color-black-005);
  }

  .v-row-group__summary {
    background: var(--v-primaryFaint-base);

    td {
      font-weight: 700;
    }
  }

  .dashboard-data-table__group-header {
    cursor: pointer;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: var(--ds-color-black-055);
    font-weight: 700;
  }

  .dashboard-data-table__group-arrow {
    display: inline-block;
    width: 14px;
    color: var(--ds-color-black-040);
  }
}
</style>
